import * as React from "react";

function isSearchInteractionTarget(target) {
  let node = target;

  while (node) {
    if (
      node.classList &&
      (node.classList.contains("boards-search-icon") ||
        node.classList.contains("search-board-component"))
    ) {
      return true;
    }

    node = node.parentElement;
  }

  return false;
}

export function useAccordionNavState({ expanded, onChange }) {
  const [searchBar, setSearchBar] = React.useState({
    showSearchIcon: true,
    showSearchBar: false,
  });

  const handleSearch = React.useCallback((event) => {
    event.stopPropagation();
    setSearchBar({
      showSearchIcon: false,
      showSearchBar: true,
    });
  }, []);

  const handleExpandClick = React.useCallback(
    (event) => {
      event.stopPropagation();
      onChange(event, !expanded);
    },
    [expanded, onChange]
  );

  const handleSummaryClick = React.useCallback(
    (event) => {
      if (isSearchInteractionTarget(event.target)) {
        return;
      }

      handleExpandClick(event);
    },
    [handleExpandClick]
  );

  return {
    searchBar,
    setSearchBar,
    handleSearch,
    handleExpandClick,
    handleSummaryClick,
  };
}
